<template>
  <div style="display: grid; justify-content: center; align-items: center">
    <div style="display: inline-flex; justify-content: center">
      <a class="bluelink" v-if="item.product_website"
        :href="`/rating/userbank?bank_id=${item.bank_id}&product_id=${item.product_website.id}`" target="_blank">{{
          item.product_website.name }}</a>
      <a class="bluelink" v-if="item.product_website"
        :href="`/rating/userbank?bank_id=${item.bank_id}&product_id=${item.product_website.id}&dop=true`" target="_blank">
        <BankCommnets style="margin-left: 5px" :value="item.IamComment" :bank_id="item.bank_id"
          v-if="item.product_website && item.product_website.id" :product_id="item.product_website.id" />
      </a>
    </div>
    <CalcRating :value="item.rate" :bank_id="item.bank_id" v-if="item.product_website && item.product_website.id"
      :product_id="item.product_website.id" />
  </div>
</template>
<script>
import BankCommnets from "@/components/BankComments.vue";
import CalcRating from "@/components/CalcRating.vue";

export default {
  name: "SiteRate",
  components: {
    CalcRating,
    BankCommnets,
  },
  data: () => ({}),
  props: {
    item: { type: Object }
  },
  methods: {},
  created() { },
  mounted() { },
  watch: {},
};
</script>
<style lang="sass" scoped></style>
